export const getCookieDomain = () => {
  const hostnameParts = window.location.hostname.split('.');
  return process.env.NODE_ENV === 'development'
    ? ''
    : '.' + hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1];
};
